// extracted by mini-css-extract-plugin
export default {"searchReturnList":"SearchReturnList_searchReturnList__Ls0kL","searchReturnItem":"SearchReturnList_searchReturnItem__rc5lB"};